import { render, staticRenderFns } from "./UploadedFile.vue?vue&type=template&id=2ba7b936"
import script from "./UploadedFile.vue?vue&type=script&lang=js"
export * from "./UploadedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports